<template>
  <div>
    <nav class="breadcrumb bg-white push">
      <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
      <span class="breadcrumb-item active">Messages</span>
    </nav>

    <div class="block">
      <div class="p-5">
        <div class="col-6">
          <div class="form-group">
            <label for="name" class="text-muted"
              >Max Number of tranfers allowed per account</label
            >
            <input
              v-model="total"
              type="number"
              class="form-control"
              id="name"
              required
            />
          </div>
        </div>
      </div>
      <div class="p-10">
        <button @click.prevent="totalAllowed" class="btn btn-primary">
          Set Total
        </button>
      </div>
    </div>

    <div class="block">
      <div class="p-5">
        <h5>Account registration Mail</h5>
      </div>
      <VueEditor id="editor2" v-model="registration_mail" />
      <br />
      <div class="p-10">
        <button @click.prevent="setMail(1)" class="btn btn-primary">
          set message
        </button>
      </div>
    </div>

    <div class="block">
      <div class="p-5">
        <h5>Account Verification Mail</h5>
      </div>
      <VueEditor id="editor2" v-model="verification_mail" />
      <br />
      <div class="p-10">
        <button @click.prevent="setMail(2)" class="btn btn-primary">
          set message
        </button>
      </div>
    </div>

    <div class="block">
      <div class="p-5">
        <h5>Card Mail</h5>
      </div>
      <VueEditor id="editor2" v-model="card_mail" />
      <br />
      <div class="p-10">
        <button @click.prevent="setMail(3)" class="btn btn-primary">
          set message
        </button>
      </div>
    </div>

    <div class="block">
      <div class="p-5">
        <h5>Loan Mail</h5>
      </div>
      <VueEditor id="editor2" v-model="loan_mail" />
      <br />
      <div class="p-10">
        <button @click.prevent="setMail(4)" class="btn btn-primary">
          set message
        </button>
      </div>
    </div>

    <!-- <div class="block">
      <div class="p-5">
        <h5>Grant Mail</h5>
      </div>
      <VueEditor id="editor2" v-model="grant_mail" />
      <br />
      <div class="p-10">
        <button @click.prevent="setMail(5)" class="btn btn-primary">
          set message
        </button>
      </div>
    </div> -->

    <!-- <div class="block">
      <div class="p-5">
        <h5>Grant Status Mail</h5>
      </div>
      <VueEditor id="editor2" v-model="grant_status_mail" />
      <br />
      <div class="p-10">
        <button @click.prevent="setMail(6)" class="btn btn-primary">
          set message
        </button>
      </div>
    </div> -->
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repository/RepositoryFactory";
import { VueEditor } from "vue2-editor";

const UsersRepository = RepositoryFactory.get("users");
export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      processing: false,
      accounts: [],
      txn_ban_mail: "",
      registration_mail: "",
      verification_mail: "",
      card_mail: "",
      loan_mail: "",
      grant_mail: "",
      grant_status_mail: "",
      total: 4,
    };
  },
  methods: {
    async message(data, message) {
      try {
        await UsersRepository.setNotification(data);
        this.loadSettings();
        toast.fire({
          type: "success",
          title: message + " message set successfully",
        });
      } catch (error) {
        toast.fire({
          type: "error",
          title: "Something went wrong",
        });
        console.log(error);
      }
    },
    async setTxnMail() {
      let data = {
        name: "txn_ban_mail",
        value: this.txn_ban_mail,
      };
      await this.message(data, "Transaction ban");
    },
    async setMail(type) {
      let name = "registration_mail";
      let value = this.registration_mail;
      let message = "Registration";
      if (type == 2) {
        name = "verification_mail";
        value = this.verification_mail;
        message = "Verification";
      }
      if (type == 3) {
        name = "card_mail";
        value = this.card_mail;
        message = "Card";
      }
      if (type == 4) {
        name = "loan_mail";
        value = this.loan_mail;
        message = "Loan";
      }
      if (type == 5) {
        name = "grant_mail";
        value = this.grant_mail;
        message = "Grant";
      }
      if (type == 6) {
        name = "grant_status_mail";
        value = this.grant_status_mail;
        message = "Grant Status";
      }
      let data = {
        name,
        value,
      };
      await this.message(data, message);
    },
    async totalAllowed() {
      let data = {
        name: "TOTAL_ALLOWED_TRANSFER",
        value: this.total,
      };
      await UsersRepository.setNotification(data);
      this.loadSettings();
      toast.fire({
        type: "success",
        title: "Total allowed updated",
      });
    },
    // async setVerificationMail() {
    //     let data = {
    //         name: "verification_mail",
    //         value: this.verification_mail
    //     };
    //     await this.message(data, "Verification");
    // },
    loadSettings() {
      UsersRepository.viewSettings().then((response) => {
        let settings = response.data;
        this.verification_mail = settings[5].value;
        this.registration_mail = settings[4].value;
        this.card_mail = settings[6].value;
        this.loan_mail = settings[7].value;
        this.grant_mail = settings[8].value;
        this.grant_status_mail = settings[9].value;
        this.total = settings[10].value;
      });
    },
  },
  created() {
    this.loadSettings();
  },
};
</script>
